import React, { Component } from "react";
import "../style/MailchimpSignUp.css";

import keys from "../config";
import axios from "axios";

class MailchimpSignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: ""
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(e) {
    e.preventDefault();
    const { email } = this.state;
    const url = keys.mailchimpSignUpUrl;
    const data = {
      email
    };
    try {
      const result = await axios.post(url, data);
      if (result.data) {
        localStorage.setItem("signedUp", true);
        this.props.handleUserSignUp("Hey, thanks for signing up!");
      } else {
        // User has already signed up
        this.props.handleUserSignUp(
          "You've already signed up for promotionals!"
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  handleFormChange(e) {
    e.preventDefault();
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }
  render() {
    const { email } = this.state;
    return (
      <div className="mailchimp-sign-up">
        <div className="mailchimp-intro">
          <h1 style={{ textAlign: "center" }}>Stay in the loop</h1>
          <p style={{ textAlign: "center" }}>
            No spam, no data sharing—only occasional updates, events, and
            promotions from englishmotets.com
          </p>
        </div>
        <form
          className={this.props.center ? "form--centered" : ""}
          onSubmit={this.handleSubmit}
        >
          <div className="signup-holder">
            <input
              className="signup"
              type="email"
              onChange={this.handleFormChange}
              name="email"
              value={email}
              placeholder="Email address"
            />
          </div>
          <button className="btn" type="submit">
            Add me to the list!
          </button>
        </form>
      </div>
    );
  }
}

export default MailchimpSignUp;



// WEBPACK FOOTER //
// ./src/components/MailchimpSignUp.js